import * as React from 'react';
import styles from './index.less';
import htmlReactParser from 'html-react-parser';

interface FHtmlReactParserProps {
  str: string;
}

function FHtmlReactParser({ str }: FHtmlReactParserProps) {
  return (<div className={styles.container}>{htmlReactParser(str)}</div>);
}

export default FHtmlReactParser;
